(function () {
  'use strict';

  function bindTrigger(btn) {
    btn.addEventListener('click', function () {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!answer) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        // Close: set explicit current height, then drop to 0 on next frame
        answer.style.maxHeight = answer.scrollHeight + 'px';
        requestAnimationFrame(function () {
          answer.style.maxHeight = '0px';
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        // Open: set max-height to content size; clear it after transition so
        // content can reflow freely (avoids cut-off if content grows later)
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        answer.addEventListener('transitionend', function clearOnOpen(e) {
          if (e.propertyName !== 'max-height') return;
          if (btn.getAttribute('aria-expanded') === 'true') {
            answer.style.maxHeight = 'none';
          }
          answer.removeEventListener('transitionend', clearOnOpen);
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.custom-product-faq__trigger').forEach(bindTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
